<template>
  <div>
    <drop-down :multiLevel="true">
      <md-button class="md-button md-info dropdown-toggle md-block">
        <span v-if="selectedTitle" class="item-icon">
          <i class="fas fa-map"></i>
        </span>
        {{selectedTitle}}
      </md-button>

      <div class="dropdown-menu">
        <sl-vue-tree
          v-model="nodes"
          ref="applianceMenu"
          :allowMultiselect="false"
          @select="onNodeSelect"
          @drop="onNodeDragAndDropped"
          @toggle="onNodeToggled"
          @nodedblclick="onNodeDblClick"
        >
          <template slot="title" slot-scope="{ node }">
            <span class="item-icon">
              <i class="fas fa-map" v-if="node.isLeaf"></i>
              <i class="fas fa-folder" v-if="!node.isLeaf && !node.isExpanded"></i>
              <i class="far fa-folder-open" v-if="!node.isLeaf && node.isExpanded"></i>
            </span>

            <span v-if="node.data.isEdited">
              <md-field style="display: inline;">
                <md-input
                  style="display: inline; width:100px;"
                  :value="node.title"
                  v-focus
                  v-on:keyup.enter="submitEdited(node, $event.target.value)"
                ></md-input>
              </md-field>
            </span>

            <span
              v-if="!node.data.isEdited"
              @mouseenter="onNodeMouseEnter(node, $event)"
              @mouseleave="onNodeMouseLeave(node, $event)"
            >
              {{ node.title }}
              <span v-if="!node.isLeaf">{{countOfChildren(node)}}</span>

              <md-button
                v-if="!node.isLeaf && node.data.showButton"
                class="md-button md-just-icon md-simple"
                @click="deleteParentNode()"
              >
                <md-icon class="md-size-1x">close</md-icon>
              </md-button>

              <md-button
                v-if="node.isLeaf && node.data.showButton"
                class="md-button md-just-icon md-simple"
                @click="modalOpen(node, $event)"
              >
                <md-icon class="md-size-1x">more_vert</md-icon>
              </md-button>
            </span>
          </template>

          <template slot="toggle" slot-scope="{ node }">
            <span v-if="!node.isLeaf">
              <i v-if="node.isExpanded" class="fa fa-chevron-down"></i>
              <i v-if="!node.isExpanded" class="fa fa-chevron-right"></i>
            </span>
          </template>

          <template slot="draginfo">{{selectedTitle}}</template>
        </sl-vue-tree>

        <div class="md-layout">
          <div class="md-layout-item md-size-50">
            <div class="text-center">
              <collapse-transition>
                <md-button
                  v-if="!addObjects.leaf.buttonSelected"
                  class="md-info md-sm"
                  @click="onAddMap()"
                >
                  <md-icon>add</md-icon>Map
                </md-button>
              </collapse-transition>
            </div>
            <zoom-x-transition>
              <md-field
                v-show="addObjects.leaf.buttonSelected"
                :class="[{ 'md-error': errors.has('MAP_NAME') }]"
              >
                <label>{{$lang.inputs.map_name}}</label>
                <md-input
                  v-model="addObjects.leaf.name"
                  data-vv-name="MAP_NAME"
                  name="MAP_NAME"
                  type="text"
                  ref="leafInput"
                  v-validate="modelValidations.name"
                  @keyup.enter="createNewMap()"
                  @keyup.esc="addObjects.leaf.buttonSelected = false"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('MAP_NAME')">close</md-icon>
                </slide-y-down-transition>
              </md-field>
            </zoom-x-transition>
          </div>

          <div class="md-layout-item md-size-50">
            <div class="text-center">
              <collapse-transition>
                <md-button
                  v-if="!addObjects.group.buttonSelected"
                  class="md-info md-sm"
                  @click="onAddGroup()"
                >
                  <md-icon>add</md-icon>
                  {{$lang.keys.group}}
                </md-button>
              </collapse-transition>
            </div>

            <zoom-x-transition>
              <md-field
                v-show="addObjects.group.buttonSelected"
                :class="[{ 'md-error': errors.has('GROUP_NAME') }]"
              >
                <label>{{$lang.inputs.group_name}}</label>
                <md-input
                  v-model="addObjects.group.name"
                  data-vv-name="GROUP_NAME"
                  name="GROUP_NAME"
                  type="text"
                  ref="groupInput"
                  v-validate="modelValidations.name"
                  @keyup.enter="createNewGroup()"
                  @keyup.esc="addObjects.group.buttonSelected = false"
                ></md-input>

                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('GROUP_NAME')">close</md-icon>
                </slide-y-down-transition>
              </md-field>
            </zoom-x-transition>
          </div>
        </div>
      </div>
    </drop-down>

    <modal v-if="showModal" @close="modalClose()">
      <template slot="header">
        <h4 class="modal-title">{{modalData.name}}</h4>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="modalClose()"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <md-field :class="[{ 'md-error': errors.has('MODAL_MAP_NAME') }]">
          <label>{{$lang.inputs.map_name}}</label>
          <md-input
            v-model="modalData.name"
            data-vv-name="MODAL_MAP_NAME"
            name="MODAL_MAP_NAME"
            maxlength="30"
            type="text"
            ref="editName"
            v-validate="modelValidations.name"
            @keyup.enter="modalSave()"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('MODAL_MAP_NAME')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
        <br />
      </template>

      <template slot="footer">
        <md-button class="md-primary" @click="modalSave()">{{$lang.keys.save}}</md-button>
        <md-button class="md-danger" @click="modalDelete()">{{$lang.keys.delete}}</md-button>
        <md-button class="md-simple" @click="modalClose()">{{$lang.keys.close}}</md-button>
      </template>
    </modal>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import {
  CollapseTransition,
  ZoomXTransition,
  SlideYDownTransition
} from "vue2-transitions";
import { getUserToken } from "@/storage/memoryStorage";
import config from "@/config/config";
import SlVueTree from "sl-vue-tree";
import { Modal } from "@/components";
import axios from "axios";
import Swal from "sweetalert2";
import snackBar from "@/components/SnackBar";

const focus = {
  inserted(el) {
    el.focus();
  }
};

export default {
  directives: { focus },
  components: {
    ZoomXTransition,
    CollapseTransition,
    SlideYDownTransition,
    "sl-vue-tree": SlVueTree,
    Modal,
    "snack-bar": snackBar
  },
  data() {
    return {
      modelValidations: {
        name: {
          required: true,
          max: 30,
          min: 3
        }
      },
      modalData: {},
      showModal: false,
      selectedTitle: "",
      addObjects: {
        leaf: {
          buttonSelected: false,
          name: ""
        },
        group: {
          buttonSelected: false,
          name: ""
        }
      },
      nodes: [],
      treeFind: false
    };
  },
  computed: {
    getAPPController() {
      return this.$store.getters.getAPPController;
    }
  },

  created() {
    this.loadMenuData();
  },

  methods: {
    modalSave() {
      this.$validator
        .validate("MODAL_MAP_NAME", this.modalData.name)
        .then(res => {
          if (res) {
            const applianceTree = this.$refs.applianceMenu;

            this.submitEdited(applianceTree.getSelected()[0], this.modalData.name);
            this.modalClose();
          }
        });
    },

    modalOpen(node, event) {
      this.modalData.name = node.title;
      this.modalData.node = node;

      this.showModal = true;

      this.$nextTick(() => {
        this.$refs.editName.$el.focus();
      });
    },

    modalClose() {
      this.showModal = false;
    },

    modalDelete() {
      Swal.queue([
        {
          title: this.$lang.general.are_you_sure,
          type: "warning",
          showCancelButton: true,
          cancelButtonClass: "md-button md-danger",
          cancelButtonText: this.$lang.keys.cancel,
          confirmButtonClass: "md-button md-success",
          confirmButtonText: this.$lang.keys.yes,
          buttonsStyling: false,
          showLoaderOnConfirm: true,

          preConfirm: () => {
            const applianceTree = this.$refs.applianceMenu;
            const removePaths = [];
            removePaths.push(this.modalData.node.path);

            applianceTree.remove(removePaths);
            this.deleteMap(this.modalData.node.data.ID_map);
            this.saveMenuData();
            this.setDefaultProfile();
            this.modalClose();

            Swal.insertQueueStep({
              title: this.$lang.messages.success,
              text: this.$lang.messages.success_removed_test_profile,
              type: "success",
              confirmButtonClass: "md-button md-success",
              confirmButtonText: this.$lang.keys.close,
              buttonsStyling: false,
              timer: config.timers.swalautoclose
            });
          }
        }
      ]);
    },

    saveMenuData() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/applications/controller/map-hierarchy",
        data: {
          user_token: getUserToken(),
          menu: this.nodes
        }
      }).catch(error => {
        this.$refs.snackbar.notify(this.$lang.messages.api_communication_error);
      });
    },

    loadMenuData() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/applications/controller/map-hierarchy",
        data: {
          user_token: getUserToken()
        }
      })
        .then(response => {
          this.nodes = response.data.data;
          this.setDefaultProfile();
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.code !== 610) {
              this.$refs.snackbar.notify(
                this.$lang.messages.api_communication_error
              );
            } else {
              this.setDefaultProfile();
            }
          }
        });
    },

    deleteMap(mapID) {
      if (mapID) {
        axios({
          method: "DELETE",
          url: this.$ENDPOINTS.API_W + "/applications/controller/map",
          data: {
            user_token: getUserToken(),
            ID_map: mapID
          }
        }).catch(error => {
          this.$refs.snackbar.notify(
            this.$lang.messages.api_communication_error
          );
        });
      }
    },

    selectedMap(selectedNode, emit = true) {
      selectedNode.isSelected = true;
      this.selectedTitle = selectedNode.title;
      
      if (emit) {
        this.$emit("on-selected", selectedNode.data);
      }

      this.$store.commit("setAPPController", {
        map: {
          title: selectedNode.title,
          ID_map: selectedNode.data.ID_map
        }
      });
    },

    iterateOverTree(parent) {
      if (parent) {
        parent.forEach(map => {
          if (map.children) {
            this.iterateOverTree(map.children);
          } else {
            if (map.isLeaf) {
              if (!this.treeFind) {
                this.selectedMap(map);
                this.treeFind = true;
              }
            }
          }
        });
      }
    },

    insertDefaultToMenu() {
      const defaultMapNode = {
        title: "First map",
        isLeaf: true,
        isSelected: true,
        data: {
          ID_map: null,
          buttonList: []
        }
      };
      this.nodes.push(defaultMapNode);
      this.selectedMap(defaultMapNode);
    },

    setDefaultProfile() {
      if (this.nodes.length === 0) {
        this.insertDefaultToMenu();
      } else {
        if (this.getAPPController.map.hasOwnProperty("title")) {
          this.$nextTick(() => {
            let findSaved = false;
            const mapsTree = this.$refs.applianceMenu;
            mapsTree.traverse((node, nodeModel, path) => {
              if (node.isLeaf) {
                if (
                  node.title == this.getAPPController.map.title &&
                  node.data.ID_map == this.getAPPController.map.ID_map
                ) {
                  findSaved = true;
                  this.selectedMap(node);
                }
              }
            });
            if (!findSaved) {
              this.iterateOverTree(this.nodes);
            }
          });
        } else {
          this.treeFind = false;
          this.iterateOverTree(this.nodes);

          if (!this.treeFind) {
            this.insertDefaultToMenu();
          }
        }
      }
    },

    setButtonsList(data) {
      const applianceTree = this.$refs.applianceMenu;
      const selectedMap = applianceTree.getSelected()[0];

      let nodeData = Object.assign({}, selectedMap.data);
      nodeData.buttonList = data;

      applianceTree.updateNode(selectedMap.path, {
        data: nodeData
      });

      this.saveMenuData();
    },

    setMap(data) {
      const applianceTree = this.$refs.applianceMenu;
      const selectedMap = applianceTree.getSelected()[0];

      let nodeData = Object.assign({}, selectedMap.data);
      nodeData.ID_map = data.ID;

      applianceTree.updateNode(selectedMap.path, {
        data: nodeData
      });

      this.selectedMap(applianceTree.getSelected()[0]);
      this.saveMenuData();
    },

    onAddMap() {
      this.addObjects.leaf.buttonSelected = true;
      this.$nextTick(() => {
        this.$refs.leafInput.$el.focus();
      });
    },

    createNewMap() {
      this.$validator
        .validate("MAP_NAME", this.addObjects.leaf.name)
        .then(res => {
          if (res) {
            const applianceTree = this.$refs.applianceMenu;

            this.nodes.push({
              title: this.addObjects.leaf.name,
              isLeaf: true,
              data: {
                ID_map: null,
                buttonList: []
              }
            });

            this.addObjects.leaf.buttonSelected = false;
            this.addObjects.leaf.name = "";
            this.saveMenuData();
          }
        });
    },

    onAddGroup() {
      this.addObjects.group.buttonSelected = true;
      this.$nextTick(() => {
        this.$refs.groupInput.$el.focus();
      });
    },

    createNewGroup() {
      this.$validator
        .validate("GROUP_NAME", this.addObjects.group.name)
        .then(res => {
          if (res) {
            this.nodes.push({
              title: this.addObjects.group.name,
              isExpanded: false,
              children: [],
              data: {}
            });

            this.addObjects.group.buttonSelected = false;
            this.addObjects.group.name = "";
            this.saveMenuData();
          }
        });
    },

    deleteParentNode() {
      const applianceTree = this.$refs.applianceMenu;
      const path = applianceTree.getSelected().map(node => node.path);
      const nodeChildren = applianceTree
        .getSelected()
        .map(node => node.children);

      if (nodeChildren[0].length == 0) {
        applianceTree.remove(path);
        this.saveMenuData();
      } else {
        this.$refs.snackbar.notify(this.$lang.messages.object_not_empty);
      }
    },

    countOfChildren(node) {
      let counter = 0;

      node.children.forEach(element => {
        if (element.isLeaf) {
          counter++;
        }
      });

      if (counter > 0) {
        return "(" + counter + ")";
      } else {
        return "";
      }
    },

    submitEdited(nodeSelected, newNodeTitle) {
      const applianceTree = this.$refs.applianceMenu;

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.isEdited = false;
      nodeData.showButton = false;

      applianceTree.updateNode(nodeSelected.path, {
        title: newNodeTitle,
        data: nodeData
      });

      if (nodeSelected.isLeaf) {
        this.selectedMap(applianceTree.getSelected()[0], false);
        this.saveMenuData();
      }
    },

    onNodeSelect(nodes, event) {
      if (!this.showModal) {
        const applianceTree = this.$refs.applianceMenu;
        event.stopPropagation();

        applianceTree.traverse((node, nodeModel, path) => {
          let nodeData = Object.assign({}, node.data);
          nodeData.isEdited = false;

          applianceTree.updateNode(node.path, {
            data: nodeData
          });
        });

        const selectedNode = nodes[0];
        if (selectedNode.isLeaf) {
          this.selectedMap(selectedNode);
        }
      }
    },

    onNodeDragAndDropped(nodes, position, event) {
      //this.setDefaultProfile();
      this.saveMenuData();
    },

    onNodeToggled(node, event) {
      this.saveMenuData();
    },

    onNodeMouseEnter(nodeSelected, event) {
      const applianceTree = this.$refs.applianceMenu;

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.showButton = true;

      applianceTree.updateNode(nodeSelected.path, {
        data: nodeData
      });
    },

    onNodeMouseLeave(nodeSelected, event) {
      const applianceTree = this.$refs.applianceMenu;

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.showButton = false;

      applianceTree.updateNode(nodeSelected.path, {
        data: nodeData
      });
    },

    onNodeDblClick(nodeSelected, event) {
      const applianceTree = this.$refs.applianceMenu;
      event.stopPropagation();

      applianceTree.traverse((node, nodeModel, path) => {
        let nodeData = Object.assign({}, node.data);
        nodeData.isEdited = false;
        applianceTree.updateNode(node.path, { data: nodeData });
      });

      let nodeData = Object.assign({}, nodeSelected.data);
      nodeData.isEdited = true;

      applianceTree.updateNode(nodeSelected.path, {
        data: nodeData
      });
    }
  }
};
</script>


<style lang="scss" scoped>
i {
  width: 33px;
  height: 33px;
  line-height: 33px;
  text-align: center;
}

.md-list {
  width: 320px;
  max-width: 100%;
  display: inline-block;
  vertical-align: top;
  border: 1px solid rgba(#000, 0.12);
}

.button-center {
  text-align: center;
}

.md-button {
  height: 40px;
}

.md-card-actions .md-layout-item {
  padding: 0;
}

.md-chips.md-field {
  padding: 0;
  margin: 0;
}

.items-inline {
  display: inline;
}

.md-button.md-just-icon {
  height: 35px;
}

@media only screen and (min-width: 500px) {
  .dropdown-menu {
    width: 400px;
  }
}

@media only screen and (min-width: 550px) {
  .dropdown-menu {
    width: 450px;
  }
}

@media only screen and (max-width: 450px) {
  .dropdown-menu {
    left: -55px;
  }
}

.dropdown-menu {
  min-width: 350px;
}

.text-center {
  display: flex;
}

.item-icon {
  display: inline-block;
  text-align: left;
  /* width: 20px;
  padding-right: 7px; */
}

.md-card-header .md-button + .md-button {
  margin-left: inherit;
}
</style>


<style lang="scss" scoped>
@import "./src/assets/scss/md/_variables";

.hierarchy-new-object {
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
}

.modal-container {
  color: var(
    --md-theme-default-text-primary-on-background-variant,
    rgba(0, 0, 0, 0.87)
  );
}

.md-chips.md-field .md-input {
  max-width: 90px;
}

.sl-vue-tree.sl-vue-tree-root {
  flex-grow: 1;
  overflow-x: hidden;
  overflow-y: auto;
  height: auto;
}

.sl-vue-tree {
  position: relative;
  cursor: default;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}

.sl-vue-tree.sl-vue-tree-root {
  background-color: #ffffff;
  color: #414d5c;
  border-radius: 3px;
}

.sl-vue-tree-root > .sl-vue-tree-nodes-list {
  overflow: hidden;
  position: relative;
  padding-bottom: 4px;
}

.sl-vue-tree-selected > .sl-vue-tree-node-item {
  background-color: #ffffff;
  color: #414d5c;
}
.sl-vue-tree-node-item:hover,
.sl-vue-tree-node-item.sl-vue-tree-cursor-hover {
  background-color: $green-300;
  color: #ffffff;
  cursor: pointer;
}

.sl-vue-tree-node-item {
  position: relative;
  display: flex;
  flex-direction: row;

  padding-left: 10px;
  padding-right: 10px;
  line-height: 35px;
  border: 1px solid transparent;
}

.sl-vue-tree-node-item.sl-vue-tree-cursor-inside {
  border: 1px solid rgba(255, 255, 255, 0.5);
}

@media only screen and (max-width: 500px) {
  .sl-vue-tree-gap {
    width: 10px;
    min-height: 1px;
  }
}

@media only screen and (min-width: 500px) {
  .sl-vue-tree-gap {
    width: 25px;
    min-height: 1px;
  }
}

.sl-vue-tree-toggle {
  display: inline-block;
  text-align: left;
  width: 20px;
}

.sl-vue-tree-sidebar {
  margin-left: auto;
}

.sl-vue-tree-cursor {
  position: absolute;
  border: 1px solid rgba(255, 255, 255, 0.5);
  height: 1px;
  width: 100%;
}

.sl-vue-tree-drag-info {
  position: absolute;
  background-color: $green-400;
  opacity: 0.85;
  margin-left: 20px;
  padding: 5px 10px;
}
</style>

